<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
        persistent
          v-model="dialog"
          width="1200px"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                {{ this.ingredient.name }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="black--text mt-10">
              <v-row>
                <v-col cols="8">
                  <div class="d-flex flex-row">
                    <img
                      style="width: 100px; height: 100px; border-radius: 50%"
                      :src="
                        this.ingredient.ingredientImageUrl
                          ? this.ingredient.ingredientImageUrl
                          : '/img/No_Image_Available.jpg'
                      "
                      alt="John"
                    />
                    <div class="pa-5">
                      <h3>{{ this.ingredient.name || '-'}}</h3>
                      <p>
                        {{ this.ingredient?.description || '-' }}
                      </p>
                    </div>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      @click="editIngredient"
                      right
                      depressed
                      color="primary"
                    >
                      Edit Ingredient
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row dense class="mt-6">
                <v-col
                  cols="4"
                  class="d-flex"
                  style="background-color: #f3f3f3"
                >
                  <v-list>
                    <v-list-item style="background-color: #f3f3f3">
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          Current Stock
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2 text-capitalize">
                          {{ this.ingredient?.totalStock || '-' }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-list
                    color="#F3F3F3"
                    style="border-left: 2px solid #0000001a"
                  >
                    <v-list-item color="#F3F3F3">
                      <v-list-item-content color="#F3F3F3">
                        <v-list-item-subtitle>
                          Expiry Date
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2 text-capitalize">
                          {{ this.ingredient.expiryDate | formatDate}}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-tabs class="ma-5" v-model="tab">
                    <v-tab>Stock Detail</v-tab>
                    <v-tab>General Info</v-tab>
                    <v-tab>Name Translation</v-tab>
                    <v-tab>Technical Info</v-tab>
                    <v-tab>Nutritional Values</v-tab>
                    <v-tab>Safety Restrictions</v-tab>
                    <v-tab>Authentication</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item>
                      <v-card class="ma-1" elevation="3">
                        <v-card-text class="pa-5">
                          <v-data-table
                            :headers="stockDetailHeaders"
                            :items="stockDetailItems"
                            :header-props="{
                              'sort-icon': 'mdi-unfold-more-horizontal',
                            }"
                            hide-default-footer
                          >
                            <template v-slot:item.stockVolume="{ item }">
                              {{ item.quantity }}{{ item.unit?.name }} kg
                            </template>
                            <template v-slot:item.purchasedDate="{ item }">
                              {{ item.order.orderDate | formatDate }}
                            </template>
                            <template v-slot:item.costUnit="{ item }">
                            ${{ item.cost }}
                            </template>
                            <template v-slot:item.taxUnit="{ item }">
                              ${{ item.tax }}
                            </template>
                            <template v-slot:item.lastUpdated="{ item }">
                              {{ item.updatedAt | formatDate }}
                            </template>
                            <template v-slot:item.expiryDate="{ item }">
                              {{ item.expiryDate | formatDate }}
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <!-- General Info -->
                    <v-tab-item>
                      <v-row>
                        <v-col
                          class="column_wrapper"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                        >
                          <v-list class="general-card">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-subtitle>
                                  Ingredient type
                                  <v-icon class="mb-1">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-list-item-subtitle>
                                <v-list-item-title
                                  class="text-h6 mt-2 text-capitalize"
                                >
                                  {{
                                    this.ingredient.ingredientType?.name ||
                                    "-"
                                  }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col
                          class="column_wrapper"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                        >
                          <v-list class="general-card">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-subtitle>
                                  Ingredient Verification
                                  <v-icon class="mb-1">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-list-item-subtitle>
                                <v-list-item-title
                                  class="text-h6 mt-2 text-capitalize"
                                >
                                  {{
                                    this.ingredient?.isVerified
                                      ? "Verified"
                                      : "Unverified"
                                  }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col
                          class="column_wrapper"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                        >
                          <v-list class="general-card">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-subtitle>
                                  Last Updated
                                  <v-icon class="mb-1">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-list-item-subtitle>
                                <v-list-item-title
                                  class="text-h6 mt-2 text-capitalize"
                                >
                                  {{ this.ingredient.updatedAt | formatDate }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col
                          class="column_wrapper"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                        >
                          <v-list class="general-card">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-subtitle>
                                  Main Nutrient(s)
                                  <v-icon class="mb-1">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-list-item-subtitle>
                                <v-list-item-title
                                  class="text-h6 mt-2 text-capitalize"
                                >
                                  {{this.ingredient.nutrientIds?.map(nutrient=>nutrient?.nutrient?.name).join(", ") ||  '-'}}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                      <h3 class="my-6">Market Pricing</h3>
                      <v-row>
                        <v-col
                          class="column_wrapper"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                        >
                          <v-list class="general-card">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-subtitle>
                                  Price
                                  <v-icon class="mb-1">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-list-item-subtitle>
                                <v-list-item-title
                                  class="text-h6 mt-2 text-capitalize"
                                >
                                  {{ this.ingredient.price  || 0 }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col
                          class="column_wrapper"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                        >
                          <v-list class="general-card">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-subtitle>
                                  Currency
                                  <v-icon class="mb-1">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-list-item-subtitle>
                                <v-list-item-title
                                  class="text-h6 mt-2 text-capitalize"
                                >
                                  {{ this.ingredient.currencyId }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col
                          class="column_wrapper"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                        >
                          <v-list class="general-card">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-subtitle>
                                  Quantity
                                  <v-icon class="mb-1">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-list-item-subtitle>
                                <v-list-item-title
                                  class="text-h6 mt-2 text-capitalize"
                                >
                                  {{ this.ingredient.quantity }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col
                          class="column_wrapper"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                        >
                          <v-list class="general-card">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-subtitle>
                                  Unit of Measure
                                  <v-icon class="mb-1">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-list-item-subtitle>
                                <v-list-item-title
                                  class="text-h6 mt-2 text-capitalize"
                                >
                                  {{ this.ingredient.unit?.name || "N/A" }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <!-- General Info end -->

                    <!-- Name Translation -->
                    <v-tab-item>
                      <v-card class="ma-1" elevation="3">
                        <v-card-text class="pa-5">
                          <v-data-table
                            :headers="nameTranslationHeaders"
                            :items="nameTranslationItems"
                            :header-props="{
                              'sort-icon': 'mdi-unfold-more-horizontal',
                            }"
                            hide-default-footer
                          >
                            <template v-slot:item.language="{ item }">
                              {{ item.language?.name }}
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <!-- Name Translation end -->

                    <!-- Technical Info -->
                    <v-tab-item>
                      <v-card class="ma-1" elevation="3">
                        <v-card-text class="pa-5">
                          <v-data-table
                            :headers="technicalInfoHeaders"
                            :items="ingredient.technicalInfo"
                            :header-props="{
                              'sort-icon': 'mdi-unfold-more-horizontal',
                            }"
                            hide-default-footer
                          >
                          <template v-slot:item.scientificName="{ item }">
                              {{ item.scientificName }}
                            </template>
                            <template v-slot:item.supplier="{ item }">
                              {{ item.supplier?.supplierName }}
                            </template>
                            <template v-slot:item.graphicOrigin="{ item }">
                              {{ item.graphicOrigin?.name }}
                            </template>
                            <template v-slot:item.lab_result="{ item }">
                              {{ item.lab_result }}
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <!-- Technical Info end -->

                    <!-- Nutritional Values -->
                    <v-tab-item>
                      <v-row>
                        <v-col cols="12" class="text-right">
                          <v-btn
                                v-for="item in ingredient.nutrientIds"
                                :key="item.id"
                                :class="`mr-2 ${item.nutrient.name.toLowerCase()}`"
                                x-small
                                rounded
                            outlined
                            width="70px"
                              >
                           {{ item.nutrient.name }}
                              </v-btn>
                          <!-- <v-btn
                            class="mr-2 vitamin"
                            x-small
                            rounded
                            outlined
                            width="70px"
                          >
                            Vitamin
                          </v-btn> -->
                     
                        </v-col>
                      </v-row>
                      <v-expansion-panels
                        focusable
                        flat
                        class="mt-5"
                        v-model="panel"
                      >
                        <v-expansion-panel>
                          <v-expansion-panel-header class="subtitle-2">
                            <span>Nutritional Values</span>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content class="pa-0">
                            <v-row>
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Dry Matter (DM)%
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #e939c2"
                                          >{{
                                            this.ingredient.nutritionalValues
                                              ?.dryMatter
                                          }}%</span
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Crude Fiber (CF)%
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #e939c2"
                                          >{{
                                            this.ingredient.nutritionalValues
                                              ?.crudeFiber
                                          }}%</span
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                              <!-- <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Total Digestible Fiber (TDF)%
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #e939c2"
                                          >Dummy%</span
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col> -->
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Total Digestible Nutrients (TDN)%
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #e939c2"
                                          >{{
                                            this.ingredient.nutritionalValues
                                              ?.tdn
                                          }}%</span
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Crude Protein (CP)%
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #00bd73"
                                          >{{
                                            this.ingredient.nutritionalValues
                                              ?.crudeProtein
                                          }}%</span
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Calcium (CA)%
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #002287"
                                          >{{
                                            this.ingredient.nutritionalValues
                                              ?.calcium
                                          }}%</span
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Phosphorus (P)%
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #ffb443"
                                          >{{
                                            this.ingredient.nutritionalValues
                                              ?.phosphorus
                                          }}%</span
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                            </v-row>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header class="subtitle-2 mt-2">
                            <span>Advance Nutrition Values</span>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content class="mt-5">
                            <v-row>
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Magnesium (MG)%
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #ffb443"
                                          >{{
                                            this.ingredient.nutritionalValues
                                              ?.magnesium
                                          }}%</span
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Potassium (K)%
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #ffb443"
                                          >{{
                                            this.ingredient.nutritionalValues
                                              ?.potassium
                                          }}%</span
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Chlorine (CL)%
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #ffb443"
                                          >{{
                                            this.ingredient.nutritionalValues
                                              ?.chlorine
                                          }}%</span
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Sulfur (S)%
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #ffb443"
                                          >{{
                                            this.ingredient.nutritionalValues
                                              ?.sulfur
                                          }}%</span
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Sodium (NA)%
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #ffb443"
                                          >{{
                                            this.ingredient.nutritionalValues
                                              ?.sodium
                                          }}%</span
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Zinc (ZN)%
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #ffb443"
                                          >{{
                                            this.ingredient.nutritionalValues
                                              ?.zinc
                                          }}%</span
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Vit D UI
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #9747ff">{{
                                          this.ingredient.nutritionalValues
                                            ?.vitD
                                        }}</span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Vit E UI
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #9747ff">{{
                                          this.ingredient.nutritionalValues
                                            ?.vitE
                                        }}</span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                              <v-col
                                class="column_wrapper"
                                lg="4"
                                md="4"
                                sm="6"
                                xs="6"
                              >
                                <v-list class="general-card">
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-subtitle>
                                        Vit A Value (Vit A E Carotene )UI
                                        <v-icon class="mb-1">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-list-item-subtitle>
                                      <v-list-item-title
                                        class="text-h6 mt-2 text-capitalize"
                                      >
                                        <span style="color: #9747ff">{{
                                          this.ingredient.nutritionalValues
                                            ?.vitA
                                        }}</span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                            </v-row>
                            <v-row class="mb-4">
                              <v-col cols="12">
                                <v-data-table
                                  :headers="advancedNutritionHeaders"
                                  :items="
                                    this.ingredient.nutritionalValues
                                      ?.energyPerSpecies
                                  "
                                  :header-props="{
                                    'sort-icon': 'mdi-unfold-more-horizontal',
                                  }"
                                  hide-default-footer
                                >
                                  <template v-slot:item.specie="{ item }">
                                    {{ item.specie?.name }}
                                  </template>
                                </v-data-table>
                              </v-col>
                            </v-row>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-tab-item>
                    <!-- Nutritional Values end -->

                    <!-- Safety Restrictions -->
                    <v-tab-item>
                      <v-row>
                        <v-col cols="6">
                          <label
                            >Proper Useage Instruction And Important
                            Recommendations
                            <v-icon class="mb-1">
                              mdi-alert-circle-outline</v-icon
                            >
                          </label>
                          <v-textarea
                          auto-grow
                          outlined
                          rows="10"
                          row-height="15"
                            dense
                            readonly
                            v-model="
                              ingredient.safetyRestrictions.usageInstrictions
                            "
                            :hide-details="true"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="6">
                          <label
                            >Proper Useage Instruction And Important
                            Recommendations
                            <v-icon class="mb-1">
                              mdi-alert-circle-outline</v-icon
                            >
                          </label>
                          <v-textarea
                          auto-grow
                          outlined
                          rows="10"
                          row-height="15"
                            dense
                            readonly
                            v-model="ingredient.safetyRestrictions.riskWarning"
                            :hide-details="true"
                          >
                          </v-textarea>
                        </v-col>
                      </v-row>
                      <v-data-table
                        class="py-4"
                        :headers="safetyRestrictionsSpeciesHeaders"
                        :items="ingredient.safetyRestrictions.speciesSafety"
                        :header-props="{
                          'sort-icon': 'mdi-unfold-more-horizontal',
                        }"
                        hide-default-footer
                      >
                        <template v-slot:item.species="{ item }">
                          {{ item.specie?.name }}
                        </template>
                      </v-data-table>
                    </v-tab-item>
                    <!-- Safety Restrictions end -->

                    <!-- Authentication -->
                    <v-tab-item>
                      <v-row>
                        <v-col
                          class="column_wrapper"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                        >
                          <v-list class="general-card">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-subtitle>
                                  Provider
                                  <v-icon class="mb-1">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-list-item-subtitle>
                                <v-list-item-title
                                  class="text-h6 mt-2 text-capitalize"
                                >
                                  {{
                                    this.authenticationPermissions[0]?.provider
                                  }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col
                          class="column_wrapper"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                        >
                          <v-list class="general-card">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-subtitle>
                                  Date
                                  <v-icon class="mb-1">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-list-item-subtitle>
                                <v-list-item-title
                                  class="text-h6 mt-2 text-capitalize"
                                >
                                  {{
                                    this.authenticationPermissions[0]?.date
                                      | formatDate
                                  }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col
                          class="column_wrapper"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                        >
                          <v-list class="general-card">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-subtitle>
                                  Farm Info Country
                                  <v-icon class="mb-1">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-list-item-subtitle>
                                <v-list-item-title
                                  class="text-h6 mt-2 text-capitalize"
                                >
                                  {{
                                    this.authenticationPermissions[0]
                                      ?.farmInfoCountry
                                  }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col
                          class="column_wrapper"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                        >
                          <v-list class="general-card">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-subtitle>
                                  First Name
                                  <v-icon class="mb-1">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-list-item-subtitle>
                                <v-list-item-title
                                  class="text-h6 mt-2 text-capitalize"
                                >
                                  {{
                                    this.authenticationPermissions[0]?.firstName
                                  }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col
                          class="column_wrapper"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                        >
                          <v-list class="general-card">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-subtitle>
                                  Last Name
                                  <v-icon class="mb-1">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-list-item-subtitle>
                                <v-list-item-title
                                  class="text-h6 mt-2 text-capitalize"
                                >
                                  {{
                                    this.authenticationPermissions[0]?.lastName
                                  }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col
                          class="column_wrapper"
                          lg="4"
                          md="4"
                          sm="6"
                          xs="6"
                        >
                          <v-list class="general-card">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-subtitle>
                                  Farm Province or Religion
                                  <v-icon class="mb-1">
                                    mdi-alert-circle-outline
                                  </v-icon>
                                </v-list-item-subtitle>
                                <v-list-item-title
                                  class="text-h6 mt-2 text-capitalize"
                                >
                                  {{
                                    this.authenticationPermissions[0]
                                      ?.farmProvince
                                  }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon>mdi-dots-horizontal</v-icon>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-divider class="my-8 mx-2"></v-divider>
                    <!-- Authentication end -->
                  </v-tabs-items>
                  <div class="float:right">
                    <v-card-actions style="padding-right: 0">
                      <v-spacer></v-spacer>
                      <v-btn
                        outlined
                        class="mr-2"
                        right
                        depressed
                        color="red"
                        @click="removeIngredient()"
                      >
                        Remove Product
                      </v-btn>
                      <v-btn
                        outlined
                        right
                        color="primary"
                        @click="closeModal()"
                      >
                        Cancel
                      </v-btn>
                    </v-card-actions>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>
<script>
import gql from "graphql-tag";
import loadingMixin from "@/mixins/LoadingMixin";

export default {
  apollo: {
    ingredient: {
      query: gql`
        query getIngredientById($id: Int!) {
          getIngredientById(id: $id) {
            id
            ingredientImageUrl
            name
            description
            totalStock
            updatedAt
            expiryDate
            ingredientType {
              name
            }
            isVerified
            nutrientIds{
            nutrientId
              nutrient{
                name
              }
            }
            technicalInfo {
              id
              scientificName
              graphicOriginId
              suppliers
              supplier{
                supplierName
              }
              graphicOrigin{
                name
              }
            }
            nutritionalValues {
              dryMatter
              crudeFiber
              totalDigestibleNutrients
              tdn
              crudeProtein
              calcium
              phosphorus
              magnesium
              potassium
              chlorine
              sulfur
              sodium
              zinc
              vitD
              vitE
              vitA
              energyPerSpecies {
                speciesId
                digestibleEnergy
                metabolizableEnergy
                netEnergy
                specie{
                  name
                }
              }
            }
            safetyRestrictions{
              id
              usageInstrictions
              riskWarning
              speciesSafety{
                specie{
                  name
                }
                speciesId
            
                minInclusionRatio
                maxInclusionRatio
              }
            
            }
            price
            converted_usd_price
            currencyId
            quantity
            unit {
              name
            }
          }
        }
      `,
      fetchPolicy:'network-only',
      variables() {
        return {
          id: parseInt(this.ingredientId),
        };
      },
      /* eslint-disable */
      update: (data) => data.getIngredientById,
      result({data}){
        console.log(this.ingredient, 'this ingredient')
        console.log(data, 'this ingredient data')
        this.ingredient = data.getIngredientById
        this.ingredient.safetyRestrictions = this.ingredient.safetyRestrictions || {
          usageInstrictions:"",
          riskWarning:"",
        }
      }
    },
    stockDetailItems: {
      query: gql`
        query stockDetail($ingredientId: Int!) {
          stockDetail(ingredientId: $ingredientId) {
            quantity
            order {
              orderDate
            }
            cost
            tax
            updatedAt
            expiryDate
          }
        }
      `,
      variables() {
        return {
          ingredientId: parseInt(this.ingredientId),
        };
      },
      update: (data) => data.stockDetail,
    },
    nameTranslationItems: {
      query: gql`
        query nameTranslations($ingredientId: Int!) {
          nameTranslations(ingredientId: $ingredientId) {
            name
            language {
              name
            }
          }
        }
      `,
      variables() {
        return {
          ingredientId: parseInt(this.ingredientId),
        };
      },
      update: (data) => data.nameTranslations,
    },
    technicalInfoItems: {
      query: gql`
        query technicalInfos($ingredientId: Int!) {
          technicalInfos(ingredientId: $ingredientId) {
            scientificName
            graphicOrigin {
              name
            }
            suppliers
          }
        }
      `,
      variables() {
        return {
          ingredientId: parseInt(this.ingredientId),
        };
      },
      update: (data) => data.technicalInfos,
    },

    authenticationPermissions: {
      query: gql`
        query authenticationPermissions($ingredientId: Int!) {
          authenticationPermissions(ingredientId: $ingredientId) {
            provider
            date
            farmInfoCountry
            firstName
            lastName
            farmProvince
          }
        }
      `,
      variables() {
        return {
          ingredientId: parseInt(this.ingredientId),
        };
      },
      update: (data) => data.authenticationPermissions,
    },
  },
  mounted(){
    this.startLoading();
    setTimeout(() => {
      this.stopLoading();
    }, 2000);
  },
  data() {
    return {
      panel: 0,
      tab: null,
      stockDetailHeaders: [
        {
          text: "",
          value: "stock",
          class: "black--text",
          sortable: true,
        },
        {
          text: "Stock Volume",
          value: "stockVolume",
          class: "black--text",
          sortable: true,
        },
        {
          text: "Purchased Date",
          value: "purchasedDate",
          class: "black--text",
          sortable: true,
      
        },
        {
          text: "Cost/Unit",
          value: "costUnit",
          class: "black--text",
          sortable: true,
          
        },
        {
          text: "Tax/Unit",
          value: "taxUnit",
          class: "black--text",
          sortable: true,
          
        },
        {
          text: "Last Updated",
          value: "lastUpdated",
          class: "black--text",
          sortable: true,
          
        },
        {
          text: "Expiry Date",
          value: "expiryDate",
          class: "black--text",
          sortable: true,
          
        },
      ],
      stockDetailItems: [
      
      ],
      nameTranslationHeaders: [
        {
          text: "Ingredient Name",
          value: "name",
          class: "black--text",
        },
        {
          text: "Language",
          value: "language",
          class: "black--text",
        },
      ],
      nameTranslationItems: [
       
      ],
      technicalInfoHeaders: [
        {
          text: "Scientific Name",
          value: "scientificName",
          class: "black--text",
        },
        {
          text: "Suppliers",
          value: "supplier",
          class: "black--text",
        },
        {
          text: "Geographic Origin",
          value: "graphicOrigin",
          class: "black--text",
        },
        {
          text: "Lab Results",
          value: "lab_result",
          class: "black--text",
        },
      ],
      technicalInfoItems: [
        
      ],
      advancedNutritionHeaders: [
        {
          text: "Species Name",
          value: "specie",
          class: "black--text",
        },
        {
          text: "Digestible Energy (DE) MJ/Kg",
          value: "digestibleEnergy",
          class: "black--text",
        },
        {
          text: "Metabolizable Energy (me) MJ/Kg",
          value: "metabolizableEnergy",
          class: "black--text",
        },
        {
          text: "Net Energy (nE) MJ/Kg",
          value: "netEnergy",
          class: "black--text",
        },
      ],
      advancedNutritionItems: [
       
      ],
      safetyRestrictionsSpeciesHeaders: [
        {
          text: "Species",
          value: "species",
          class: "black--text",
        },
        {
          text: "Min.Inclusion Ratio",
          value: "minInclusionRatio",
          class: "black--text",
        },
        {
          text: "Max.Inclusion Ratio",
          value: "maxInclusionRatio",
          class: "black--text",
        },
      ],
      safetyRestrictionItems: [
       {
        usageInstrictions:"",
        riskWarning:"",
       }
      ],
      authenticationPermissions: [],
      ingredient: {
        safetyRestrictions:{
          usageInstrictions:"",
          riskWarning:"",
        }
      },
    };
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    ingredientId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },

    editIngredient() {
      this.$router.push({
        path: `/feed-management/ingredient-inventory/${this.ingredientId}/edit`,
      });
    },

    removeIngredient() {
      this.ingredientsIdArr = [
        { id: this.ingredientId, name: this.ingredient.name },
      ];
      this.$emit("removeIngredient", this.ingredientsIdArr);
      this.$emit("closeDialog");
    },
  },
  mixins:[loadingMixin],
};
</script>

<style lang="scss" scoped>
.theme--light.v-chip:not(.v-chip--active) {
  background: #ffb443;
  color: #ffffff;
}

.column_wrapper {
  display: flex;
  max-height: 100px;
  flex-flow: column wrap;
  border-radius: 5px;
  margin-bottom: 10px;
}

.column_wrapper small {
  color: #787878;
}

.general-card {
  background: #e5f8f1;
  padding: 10px;
  margin-right: 4px;
}

.v-expansion-panel-header{
  background: #e4e4e480;
}

.v-expansion-panel-header--active {
  background: #fff7ec;
  border: 1px solid #ffb443;
  border-radius: 5px;
  font-size: 18px;
}

.vitamin {
  color: #9747ff;
  background: #9747ff1a;
  text-transform: none !important;
}

.protein {
  color: #00bd73;
  background: #e5f8f1;
  text-transform: none !important;
}

.energy {
  color: #f03737;
  background: #fdebeb;
  text-transform: none !important;
}

.fibre {
  color: #e939c2;
  background: #e939c21a;
  text-transform: none !important;
}

.fat {
  color: #002287;
  background: #ebf4ff;
  text-transform: none !important;
}

.mineral {
  color: #ffb443;
  background: #fff0d9;
  text-transform: none !important;
}
.additive {
  color: #9543ff;
  background: #f7d9ff;
  text-transform: none !important;
}

.v-tab {
  text-transform: none !important;
}
::v-deep .v-expansion-panel-content__wrap {
  padding: 0px !important;
}
</style>
